export default __webpack_public_path__ + "static/helphcase1-49d0378898e9d29f9150b992cf6f5399.png";